"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const moment_1 = __importDefault(require("moment"));
const suiteFormStyle_1 = require("./suiteFormStyle");
const PaymentFormStyle_1 = require("../../paymentForm/PaymentFormStyle");
const FormSuite_1 = require("../../../hooks/FormSuite");
const constants_1 = require("../../../assets/constants/constants");
const countriesArray_1 = require("../../../assets/constants/countriesArray");
const api_1 = require("../../../services/api");
const validations_1 = require("../../../utils/validations");
const Telephone_1 = __importDefault(require("../../telephone/Telephone"));
const regex_1 = require("../../../utils/regex");
const SuiteFormRequired = ({ field, formKey = 'suites' }) => {
    const [cities, setCities] = (0, react_1.useState)([]);
    const { form } = (0, FormSuite_1.useFormSuit)();
    const [selectedCountry, setSelectedCountry] = (0, react_1.useState)('');
    const documentTypeHandle = (0, react_1.useCallback)(name => {
        const suitesValues = form.getFieldValue([formKey]);
        suitesValues[name] = Object.assign(Object.assign({}, suitesValues[name]), { documentGuestRequired: '' });
        form.setFieldsValue({ [formKey]: suitesValues });
    }, [form, formKey]);
    (0, react_1.useEffect)(() => {
        if (formKey === 'suites')
            setSelectedCountry('Brazil');
    }, [formKey]);
    const selectStateHandle = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const state = form.getFieldValue([formKey, field.key, 'addressState']);
        const { data } = yield api_1.ibge.get(`localidades/estados/${state}/municipios`);
        setCities(data);
    }), [field.key, form, formKey]);
    const cepHandle = (0, react_1.useCallback)((onlyValidation = false) => __awaiter(void 0, void 0, void 0, function* () {
        const cep = form.getFieldValue([formKey, field.key, 'addressCep']);
        const rawCep = cep ? cep.replace(constants_1.CEP_REGEX, '').replace('-', '') : '';
        if (rawCep.length === constants_1.MAX_CEP_LENGHT) {
            return api_1.brasilApi
                .get(`cep/v1/${rawCep}`)
                .then(({ data }) => {
                var _a;
                if (onlyValidation)
                    return Promise.resolve();
                const formValue = form.getFieldsValue();
                form.setFieldsValue(Object.assign(Object.assign({}, formValue), { [formKey]: [
                        Object.assign(Object.assign({}, (_a = formValue[formKey]) === null || _a === void 0 ? void 0 : _a[field.key]), { addressCep: data.cep.toString(), addressName: data.street, addressDistrict: data.neighborhood, addressState: data.state, addressCity: data.city, key: 0 }),
                    ] }));
                return Promise.resolve();
            })
                .catch(error => {
                if (error.response) {
                    const { status, data } = error.response;
                    const { errors, message } = data;
                    if (status === 404) {
                        const messageError = constants_1.ERRO_CEP[errors[0].message];
                        const messageReturn = messageError || (constants_1.ERRO_CEP[message] ? constants_1.ERRO_CEP[message] : 'CEP inválido');
                        return Promise.reject(new Error(messageReturn));
                    }
                    return Promise.reject(new Error(message));
                }
                return Promise.reject(new Error(error.message));
            });
        }
        if (rawCep.length > 0) {
            return Promise.reject(new Error('Tamanho inválido deve ser 8 caracteres'));
        }
        return Promise.resolve();
    }), [field.key, form, formKey]);
    const handlezipCodeChange = () => {
        return new Promise((resolve, reject) => {
            cepHandle(true)
                .then(() => {
                resolve();
            })
                .catch(e => {
                reject(e.message);
            });
        });
    };
    (0, react_1.useEffect)(() => {
        const country = form.getFieldValue([formKey, field.name, 'country']);
        if (selectedCountry !== country && formKey === 'checkin') {
            setSelectedCountry(country);
        }
    }, [form.getFieldValue([formKey, field.name, 'country']), formKey]);
    return (react_1.default.createElement(antd_1.Col, { span: 24 },
        react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { flex: "1" },
                react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { style: { display: 'none' }, name: [field.name, 'id'] },
                    react_1.default.createElement(suiteFormStyle_1.InputStyled, null)),
                react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, label: "Nome Completo", name: [field.name, 'fullnameRequired'], rules: [
                        () => ({
                            validator(rule, value) {
                                const valueTrim = value === null || value === void 0 ? void 0 : value.trim();
                                if (!valueTrim) {
                                    return Promise.reject(new Error('Por favor informe o nome'));
                                }
                                if (!valueTrim.match(regex_1.REGEX_LETTERS_SPACES)) {
                                    return Promise.reject(new Error('Por favor remova os caracteres especiais'));
                                }
                                if (!valueTrim.match(regex_1.REGEX_FULL_NAME)) {
                                    return Promise.reject(new Error('Por favor informe o nome completo'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ], style: {
                        width: '100%',
                    } },
                    react_1.default.createElement(suiteFormStyle_1.InputStyled, { placeholder: "Nome completo do h\u00F3spede" })))),
        react_1.default.createElement(antd_1.Row, { justify: "space-between" },
            react_1.default.createElement(antd_1.Col, { xs: {
                    span: 24,
                    flex: '1',
                }, sm: {
                    span: 24,
                    flex: '1',
                }, lg: 7 },
                react_1.default.createElement(antd_1.Row, { wrap: false },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { style: {
                            minWidth: '90px',
                            maxWidth: '90px',
                            marginRight: '5px',
                            display: 'block',
                        }, labelCol: { span: 24 }, name: [field.name, 'documentTypeGuestRequired'], label: "Tipo", help: false, initialValue: "CPF" },
                        react_1.default.createElement(PaymentFormStyle_1.SelectStyled, { onChange: () => documentTypeHandle(field.name), size: "large" },
                            react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { value: "CPF" }, "CPF"),
                            react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { value: "RG" }, "RG"),
                            react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { value: "PASSPORT" }, "PASS"))),
                    react_1.default.createElement(antd_1.Col, { flex: "1" },
                        react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, name: [field.name, 'documentGuestRequired'], label: "Documento", validateTrigger: "onBlur", rules: [
                                {
                                    required: true,
                                },
                                () => ({
                                    validator(rule, value) {
                                        if (!value) {
                                            return Promise.resolve();
                                        }
                                        const docType = form.getFieldValue([formKey, field.key, 'documentTypeGuestRequired']);
                                        if (docType === 'CPF') {
                                            if (!(0, validations_1.validateCPF)(value)) {
                                                return Promise.reject(new Error('Insira um CPF válido'));
                                            }
                                            return Promise.resolve();
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ], style: {
                                flex: '1',
                            } }, (() => {
                            switch (form.getFieldValue([formKey, field.key, 'documentTypeGuestRequired'])) {
                                case 'CPF':
                                    return react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { type: "tel", mask: "111.111.111-11", placeholder: "XXX.XXX.XXX-XX" });
                                case 'RG':
                                    return react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { mask: "11.111.111-*", placeholder: "XX.XXX.XXX-X" });
                                case 'PASSPORT':
                                    return react_1.default.createElement(suiteFormStyle_1.InputStyled, null);
                                default:
                                    return react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { type: "tel", mask: "111.111.111-11", placeholder: "XXX.XXX.XXX-XX" });
                            }
                        })())))),
            react_1.default.createElement(antd_1.Col, { xs: {
                    span: 24,
                    flex: '1',
                }, sm: {
                    span: 24,
                    flex: '1',
                }, lg: 7 },
                react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, style: { minWidth: '150px' }, name: [field.name, 'birthdayRequired'], label: "Data de Nascimento", validateTrigger: "onBlur", rules: [
                        {
                            required: true,
                        },
                        () => ({
                            validator(rule, value) {
                                if (!value) {
                                    return Promise.resolve();
                                }
                                const dateFormat = 'DD/MM/YYYY';
                                const inputDate = (0, moment_1.default)(value, dateFormat, true);
                                if (!(0, moment_1.default)(inputDate).isValid()) {
                                    return Promise.reject(new Error('Insira uma data válida'));
                                }
                                const years = (0, moment_1.default)().diff(inputDate, 'years');
                                if (years < 18) {
                                    return Promise.reject(new Error('O hóspede principal precisa ter mais de 18 anos'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ] },
                    react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { type: "tel", mask: "11/11/1111", placeholder: "dd/mm/aaaa" }))),
            react_1.default.createElement(antd_1.Col, { xs: {
                    span: 24,
                    flex: '1',
                }, sm: {
                    span: 24,
                    flex: '1',
                }, lg: 7 },
                react_1.default.createElement("div", { className: "ant-col ant-col-24 ant-form-item-label" },
                    react_1.default.createElement("label", { htmlFor: "suites_0_ddiRequired", className: "ant-form-item-required", title: "Celular", style: { color: '#c31c4a', fontWeight: 500 } }, "Celular")),
                react_1.default.createElement(Telephone_1.default, { form: form, required: true, ddiFieldName: [formKey, field.name, 'ddiRequired'], ddiFormItemProps: {
                        initialValue: '55',
                        name: [field.name, 'ddiRequired'],
                    }, phoneFieldName: [formKey, field.name, 'phoneRequired'], phoneFormItemProps: {
                        name: [field.name, 'phoneRequired'],
                    }, phoneInputProps: {
                        placeholder: '(XX) XXXXX-XXXX',
                    } }))),
        react_1.default.createElement(antd_1.Typography, null, "Endere\u00E7o:"),
        formKey !== 'suites' && (react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { xs: 24, sm: 24, lg: 24 },
                react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, name: [field.name, 'country'], label: "Pa\u00EDs", help: false, rules: [
                        {
                            required: true,
                        },
                    ], initialValue: "Brazil" },
                    react_1.default.createElement(PaymentFormStyle_1.SelectStyled, { onChange: country => {
                            setSelectedCountry(country);
                        }, showSearch: true, optionFilterProp: "children", size: "large" }, countriesArray_1.COUNTRIES.map(country => {
                        !selectedCountry && setSelectedCountry('Brazil');
                        return (react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { key: country.nome, value: country.engName }, country.nome));
                    })))))),
        selectedCountry === 'Brazil' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, name: [field.name, 'addressCep'], label: "CEP", rules: [
                            {
                                required: true,
                            },
                            { validator: handlezipCodeChange },
                        ] },
                        react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { type: "tel", mask: "11111-111", placeholder: "00000-000", onChange: () => cepHandle(false) }))),
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, name: [field.name, 'addressName'], label: "Rua", help: false, rules: [
                            {
                                required: true,
                            },
                        ] },
                        react_1.default.createElement(suiteFormStyle_1.InputStyled, null))),
                react_1.default.createElement(antd_1.Col, { xs: 24, sm: 24, lg: 7 },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, name: [field.name, 'addressNumber'], label: "N\u00FAmero", help: false, rules: [
                            {
                                required: true,
                            },
                        ] },
                        react_1.default.createElement(suiteFormStyle_1.InputStyled, { type: "number" })))),
            react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, name: [field.name, 'addressComplement'], label: "Complemento", help: false, rules: [
                            {
                                required: false,
                            },
                        ] },
                        react_1.default.createElement(suiteFormStyle_1.InputStyled, null))),
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, name: [field.name, 'addressDistrict'], label: "Bairro", help: false, rules: [
                            {
                                required: true,
                            },
                        ] },
                        react_1.default.createElement(suiteFormStyle_1.InputStyled, null))),
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: {
                        span: 7,
                    } },
                    react_1.default.createElement(antd_1.Row, { wrap: false },
                        react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, name: [field.name, 'addressState'], label: "Estado", help: false, rules: [
                                {
                                    required: true,
                                },
                            ], style: {
                                minWidth: '70px',
                                maxWidth: '70px',
                                marginRight: '5px',
                            } },
                            react_1.default.createElement(PaymentFormStyle_1.SelectStyled, { onChange: selectStateHandle, size: "large" }, constants_1.STATES.map(state => {
                                return (react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { key: state.initials, value: state.initials }, state.initials));
                            }))),
                        react_1.default.createElement(antd_1.Col, { flex: "1" },
                            react_1.default.createElement(suiteFormStyle_1.FormItemFormularyRequired, { labelCol: { span: 24 }, name: [field.name, 'addressCity'], label: "Cidade", help: false, rules: [
                                    {
                                        required: true,
                                    },
                                ], style: {
                                    minWidth: '90px',
                                } },
                                react_1.default.createElement(PaymentFormStyle_1.SelectStyled, { showSearch: true, optionFilterProp: "children", size: "large" }, cities.map(city => {
                                    return (react_1.default.createElement(PaymentFormStyle_1.SelectStyled.Option, { key: city.id, value: city.id }, city.nome));
                                }))))))))),
        react_1.default.createElement(suiteFormStyle_1.FormHelper, null, "Todos os campos s\u00E3o obrigat\u00F3rios.")));
};
exports.default = SuiteFormRequired;
